import BalanceOfAbi from "../utils/BalanceOfAbi.json";
import CreatePoolAbi from "../utils/CreatePoolAbi.json";
import TradePoolAbi from "../utils/TradePoolAbi.json";
import crashGameAbi from "../utils/CrashGameAbi.json";
import gameLiquidity from "../utils/GameLiquidity.json";
import OracleAbi from "../utils/OracleAbi.json";
import web3NoAccount from "./web3";

const getContract = (abi, address, web3) => {
  const _web3 = web3 ?? web3NoAccount;
  return new _web3.eth.Contract(abi, address);
};

export const getBalance = (address, web3) => {
  return getContract(BalanceOfAbi, address, web3);
};
export const getPool = (address, web3) => {
  return getContract(CreatePoolAbi, address, web3);
};

export const getTrade = (address, web3) => {
  return getContract(TradePoolAbi, address, web3);
};
export const getOracle = (address, web3) => {
  return getContract(OracleAbi, address, web3);
};

export const getCrashGameContract = (address, web3) => {
  return getContract(crashGameAbi, address, web3);
};

export const getGameLiquidityContract = (address, web3) => {
  return getContract(gameLiquidity, address, web3);
};
